import { useParams } from 'react-router-dom';
import { List } from '../../../../../../../../commonComponents/CardList';
import { useGroupsCard } from '../hooks';
import { GroupItem } from './GroupItem';

export const GroupList = () => {
  const { id: dsoId } = useParams();
  const { data, handleScrollList, isInitialLoading, isLoading } = useGroupsCard(dsoId);

  return (
    <List
      data={data}
      onScroll={handleScrollList}
      renderItem={({ item }) => <GroupItem dsoId={dsoId} item={item} />}
      isLoading={isInitialLoading || isLoading}
    />
  );
};
